import { useEffect, useState, useCallback } from "react";
import { ErrorBoundary, useApi, useMessenger } from "@bwevents/components";
import { Routes, Route, useLocation } from "react-router-dom";
import { AppLoading, Forbidden, Error } from "common/pages";
import LayoutCustom from "common/components/layout/LayoutCustom";

// Components
import Home from "pages/Home";
import Register from "pages/Register";
import Login from "pages/Login";
import ResetPassword from "pages/ResetPassword";
import ForgotPassword from "pages/ForgotPassword";
import Search from "pages/Search";
import NotFound from "pages/NotFound";
import Profile from "pages/Profile";
import Event from "pages/Event";
import Activate from "./pages/Activate";

function App({ version }) {
  const { pathname } = useLocation();
  const [account, setAccount] = useState();
  const [permissions, setPermissions] = useState();
  const [isInitialized, setIsInitialized] = useState(false);
  const [isLoading, setIsLoading] = useState();
  const [hasAppError, setHasAppError] = useState(false);
  const [hasContentError, setHasContentError] = useState(false);
  const [showForbidden, setShowForbidden] = useState(false);
  const [showNotFound, setShowNotFound] = useState(false);
  // const [hideFooterLayout, setHideFooterLayout] = useState(true)

  const { messenger, messengerNode } = useMessenger();

  const api = useApi({
    messenger,
    setIsLoading,
    onLogout: setAccount,
    onError: useCallback(() => setHasContentError(true), [setHasContentError]),
    onForbidden: useCallback(() => setShowForbidden(true), [setShowForbidden]),
    onNotFound: useCallback(() => setShowNotFound(true), [setShowNotFound]),
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [pathname]);
  useEffect(() => {
    window.eventVersion = { version };
  }, [version]);

  // - Get Account
  useEffect(() => {
    api(`api/providers/${process.env.REACT_APP_SLUG}/users/me/`, {
      ignoreError: true,
    }).then(({ ok, body }) => {
      if (ok) setAccount(body.data);
      setIsInitialized(true);
    });
  }, [api]);

  const layoutProps = {
    api,
    account,
    messenger,
    setAccount,
    setIsInitialized,
    // hideFooterLayout,
    // setHideFooterLayout
  };

  const defaultProps = {
    api,
    messenger,
    account,
    setAccount,
    permissions,
    setPermissions,
    isLoading,
    setIsLoading,
    // hideFooterLayout,
    // setHideFooterLayout
  };

  return (
    <>
      {messengerNode}

      <ErrorBoundary
        hasError={hasAppError}
        setHasError={setHasAppError}
        Error={<Error />}
      >
        {isInitialized ? (
          <LayoutCustom {...layoutProps}>
            <ErrorBoundary
              hasError={hasContentError}
              setHasError={setHasContentError}
              Error={<Error />}
            >
              {showForbidden ? (
                <Forbidden />
              ) : showNotFound ? (
                <NotFound />
              ) : (
                <>
                  <Routes>
                    <Route path="/" element={<Home {...defaultProps} />} />
                    {!account && (
                      <Route
                        path="/login"
                        element={<Login {...defaultProps} />}
                      />
                    )}
                    {!account && (
                      <Route
                        path="/register"
                        element={<Register {...defaultProps} />}
                      />
                    )}
                    {account && (
                      <Route
                        path="/profile"
                        element={<Profile {...defaultProps} />}
                      />
                    )}
                    <Route
                      path="/forgot-password"
                      element={<ForgotPassword {...defaultProps} />}
                    />
                    <Route
                      path="/reset-password"
                      element={<ResetPassword {...defaultProps} />}
                    />
                    <Route
                      path="/search"
                      element={<Search {...defaultProps} />}
                    />
                    <Route
                      path="/event/:eventId"
                      element={<Event {...defaultProps} />}
                    />
                    <Route
                      path="/activate"
                      element={<Activate {...defaultProps} />}
                    />
                    <Route path="*" element={<NotFound {...defaultProps} />} />
                  </Routes>
                </>
              )}
            </ErrorBoundary>
          </LayoutCustom>
        ) : (
          <AppLoading />
        )}
      </ErrorBoundary>
    </>
  );
}

export default App;
